import { Box } from '#/components/Box/Box';
import { LegacyTertiaryButton } from '#/components/LegacyButton/LegacyTertiaryButton';
import { BodySmall } from '#/components/Text/BodySmall';
import { useI18n } from '#/i18n/hooks/useI18n';
import { colors } from '#/theme/theme';

import { Card } from './Card';
import { Container } from './Container';

type Props = {
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line typescript/no-explicit-any
  job: Record<string, any>;
  title: string;
  onReset: () => void;
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line typescript/no-explicit-any
  siblings: any;
  setRelatedJobsShowing: (arg0: boolean) => void;
};

export function JobDescription({
  job,
  title,
  siblings,
  setRelatedJobsShowing,
  onReset,
}: Props) {
  const { i18n } = useI18n();

  return (
    <Container>
      <Box py="8px">
        <Card content={{ ...job, name: title }} />

        <Box pb={[12, null, 24]} pt={12} px={[24, null, 44]}>
          <LegacyTertiaryButton
            onClick={() => {
              if (siblings) {
                setRelatedJobsShowing(true);
              } else {
                onReset();
              }
            }}
            qaId="title-not-match"
          >
            <BodySmall styleAs="h5" textAlign="left">
              {i18n("This doesn't match my job")}
            </BodySmall>
          </LegacyTertiaryButton>

          <BodySmall
            color={colors.lightContentGrey}
            styleAs="bodySmall"
            mt="8px"
          >
            {i18n(`Job descriptions serve as a guide and may not be specific to your role.
              Required experience and responsibilities will vary depending on your individual role.`)}
          </BodySmall>
        </Box>
      </Box>
    </Container>
  );
}
